export const addChildren = (app: any, boardContainer: any, rocket: any) => {
    app?.stage.addChild(boardContainer)
    boardContainer.addChild(rocket)
}